export default __webpack_public_path__ + "static/media/mall.a43c3004.png";